import { basic, initSidebar, initTopbar } from './modules/layouts';
import { categoryCollapse } from './modules/plugins';

basic();
initSidebar();
initTopbar();
categoryCollapse();
